import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AlertContainerComponent } from './components/alert-container/alert-container.component';
import { AlertComponent } from './components/alert/alert.component';
import { ButtonComponent } from './components/clickables/button.component';
import { LinkComponent } from './components/clickables/link.component';
import { CookieBannerDialogComponent } from './components/cookie-banner-dialog/cookie-banner-dialog.component';
import { CookieBannerComponent } from './components/cookie-banner/cookie-banner.component';
import { DialogModule } from './components/dialog/dialog.module';
import { DialogFooterActionsComponent } from './components/dialog/dialog-footer-actions/dialog-footer-actions.component';
import { DialogHeadingComponent } from './components/dialog/dialog-heading/dialog-heading.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { FadeInOnScrollDirective } from './components/directives/fade-in-on-scroll.directive';
import { ErrorComponent } from './components/error/error.component';
import { IconComponent } from './components/icon/icon.component';
import { LanguageSelectDialogComponent } from './components/language-select-dialog/language-select-dialog.component';
import { LanguageSelectComponent } from './components/language-select/language-select.component';
import { LanguageWarningComponent } from './components/language-warning/language-warning.component';
import { LoadingAnimationComponent } from './components/loading-animation/loading-animation.component';
import { LogoComponent } from './components/logo/logo.component';
import { NavigationFooterComponent } from './components/navigation-footer/navigation-footer.component';
import { NavigationHeaderComponent } from './components/navigation-header/navigation-header.component';
import { IframeOnloadDirective } from './components/newsletter/iframe-onload.directive';
import { PageErrorStateComponent } from './components/page-error-state/page-error-state.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';

@NgModule({
  declarations: [
    LogoComponent,
    IconComponent,
    ButtonComponent,
    LinkComponent,
    NavigationHeaderComponent,
    NavigationFooterComponent,
    LoadingAnimationComponent,
    LanguageSelectComponent,
    CookieBannerComponent,
    CookieBannerDialogComponent,
    LanguageSelectDialogComponent,
    LanguageWarningComponent,
    AlertComponent,
    AlertContainerComponent,
    ErrorComponent,
    PageErrorStateComponent,
    PageNotFoundComponent,
    FadeInOnScrollDirective,
    IframeOnloadDirective,
    ToggleSwitchComponent,
    DialogFooterActionsComponent,
    DialogHeadingComponent,
    EmptyStateComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslateModule.forChild(),
    DialogModule,
  ],
  exports: [
    LogoComponent,
    IconComponent,
    ButtonComponent,
    LinkComponent,
    NavigationHeaderComponent,
    NavigationFooterComponent,
    LoadingAnimationComponent,
    LanguageSelectComponent,
    CookieBannerComponent,
    CookieBannerDialogComponent,
    LanguageSelectDialogComponent,
    LanguageWarningComponent,
    AlertComponent,
    AlertContainerComponent,
    ErrorComponent,
    PageErrorStateComponent,
    PageNotFoundComponent,
    FadeInOnScrollDirective,
    IframeOnloadDirective,
    ToggleSwitchComponent,
    DialogModule,
    DialogFooterActionsComponent,
    DialogHeadingComponent,
    EmptyStateComponent,
  ],
})
export class SharedCoreModule {}
